import { Pipe, PipeTransform } from '@angular/core';
import { SchoolInfo } from 'services/application/application.service';

@Pipe({
    name: 'schoolName',
})
export class SchoolNamePipe implements PipeTransform {
    transform(schoolnumber: string, Schools: SchoolInfo[], ShowNumber?: boolean) {
        if (!schoolnumber) {
            return '';
        }

        const entry = (Schools || []).find(s => s.SchoolNumber === schoolnumber);

        if (entry && !!entry.SchoolName) {
            return `${entry.SchoolName}${ShowNumber === true ? ` (${entry.SchoolNumber})` : ''}`;
        } else {
            return schoolnumber;
        }
    }
}
